export default "__VITE_ASSET__Ro63hoy5__"